import type { SelectOption } from '@civilgrid/ui/components';
import { PlanType } from '~/common/types';

export interface NewOrgFormValues {
  orgName: string;
  billingContacts: string;
  planType: PlanType;

  // per project cost:
  linearUnits: number;
  linearCostRural: number;
  linearCostUrban: number;
  polygonUnits: number;
  polygonCostRural: number;
  polygonCostUrban: number;
}

export interface SandboxOrgFormValues {
  orgName: string;
}

// NOTE: This is nearly identical to the "emailRegex" const in ~/components2/forms/common.
// Removing the "g" (global) flag at the very end allows this to works, since we are
// not checking for multiple matches within each substring;
export const emailRegex = /^[\w-.]+\+?[\w-.]+@([\w-]+\.)+[\w-]{2,64}$/;

export function splitByComma(string: string) {
  const split = string.split(',').map((email) => email.trim());
  // removes duplicates
  const unique = Array.from(new Set(split));
  return unique;
}

export const orgPlanTypes: SelectOption[] = [
  {
    label: 'Trial',
    value: PlanType.Trial,
  },
  {
    label: 'Pilot',
    value: PlanType.Pilot,
  },
  {
    label: 'Tier 1',
    value: PlanType.Tier1,
  },
  {
    label: 'Tier 2',
    value: PlanType.Tier2,
  },
  {
    label: 'Tier 3',
    value: PlanType.Tier3,
  },
  {
    label: 'Data Request',
    value: PlanType.DataRequest,
  },
  {
    label: 'Partner',
    value: PlanType.Partner,
  },
];

export const subscriptionFieldsData: {
  [key: string]: { name: keyof NewOrgFormValues; label: string };
} = {
  linearUnits: { name: 'linearUnits', label: 'Linear Project Units (miles)' },
  linearCostRural: {
    name: 'linearCostRural',
    label: 'Linear Project Unit Cost - Rural (cents)',
  },
  linearCostUrban: {
    name: 'linearCostUrban',
    label: 'Linear Project Unit Cost - Urban (cents)',
  },
  polygonUnits: {
    name: 'polygonUnits',
    label: 'Polygon Project Units (acres)',
  },
  polygonCostRural: {
    name: 'polygonCostRural',
    label: 'Polygon Project Unit Cost - Rural (cents)',
  },
  polygonCostUrban: {
    name: 'polygonCostUrban',
    label: 'Polygon Project Unit Cost - Urban (cents)',
  },
};

export const allowDecimal = [subscriptionFieldsData.linearUnits.name, subscriptionFieldsData.polygonUnits.name];
